import { render, staticRenderFns } from "./repairRecord.vue?vue&type=template&id=64317ba0&scoped=true&"
import script from "./repairRecord.vue?vue&type=script&lang=js&"
export * from "./repairRecord.vue?vue&type=script&lang=js&"
import style0 from "./repairRecord.vue?vue&type=style&index=0&id=64317ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64317ba0",
  null
  
)

export default component.exports